import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Terms from './Terms';
import termsStore from '../stores/TermsStore';
import Profile from './Profile';
import profileStore from '../stores/ProfileStore';
import Stickers from './Stickers';
import stickerStore from '../stores/StickerStore';
import StickerDetails from './StickerDetails';
import StickerPhotos from './StickerPhotos';
import StickerLocation from './StickerLocation';
import StickerMap from './StickerMap';
import Scanner from './Scanner';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  }
});

class Main extends Component {
  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
  }

  render() {
    const { classes } = this.props;
   
    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          <Route exact path="/" render={(props) =>  <Redirect to='/stickers' {...props} /> } />
          <Route exact path="/terms" render={(props) => <Terms {...props} termsStore={termsStore} />} />
          <Route exact path="/profile" render={(props) => <Profile {...props} profileStore={profileStore} />} />
          <Route exact path="/stickers" render={(props) => <Stickers {...props} stickerStore={stickerStore} />} />
          <Route exact path="/stickers/:id" render={(props) => <StickerDetails {...props} stickerStore={stickerStore} />} />
          <Route exact path="/stickers/:id/photos" render={(props) => <StickerPhotos {...props} stickerStore={stickerStore} />} />
          <Route exact path="/stickers/:id/location" render={(props) => <StickerLocation {...props} stickerStore={stickerStore} />} />
          <Route exact path="/map" render={(props) => <StickerMap {...props} stickerStore={stickerStore} />} />
          <Route exact path="/scanner" render={(props) => <Scanner {...props} stickerStore={stickerStore} />} />
        </Switch>
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Main);